import React, { useState } from 'react'

interface MessageImageProps {
  imageUrl: string
  alt?: string
  className?: string
}

export const MessageImage: React.FC<MessageImageProps> = ({
  imageUrl,
  alt = 'Imagem da mensagem',
  className = ''
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const [hasError, setHasError] = useState(false)

  const handleImageLoad = () => {
    setIsLoading(false)
  }

  const handleImageError = () => {
    setIsLoading(false)
    setHasError(true)
  }

  const handleImageClick = () => {
    // Abrir imagem em nova aba para visualização completa
    window.open(imageUrl, '_blank')
  }

  if (hasError) {
    return (
      <div className={`d-flex align-items-center justify-content-center bg-light rounded p-3 ${className}`}>
        <div className="text-muted text-center">
          <i className="bi bi-image-fill fs-2x mb-2"></i>
          <div className="small">Erro ao carregar imagem</div>
        </div>
      </div>
    )
  }

  return (
    <div className={`position-relative ${className}`}>
      {isLoading && (
        <div className="position-absolute top-50 start-50 translate-middle">
          <div className="spinner-border spinner-border-sm text-primary" role="status">
            <span className="visually-hidden">Carregando...</span>
          </div>
        </div>
      )}
      
      <img
        src={imageUrl}
        alt={alt}
        className="img-fluid rounded cursor-pointer"
        style={{
          maxWidth: '200px',
          maxHeight: '200px',
          objectFit: 'cover',
          opacity: isLoading ? 0 : 1,
          transition: 'opacity 0.3s ease'
        }}
        onLoad={handleImageLoad}
        onError={handleImageError}
        onClick={handleImageClick}
        title="Clique para ampliar"
      />
    </div>
  )
}